import {
    Component,
    Input,
    OnInit,
    HostBinding,
    OnDestroy
} from '@angular/core';
import {INode, INodeOptions} from "@app/workflow-common/diagram-view2/models/node.model";
import {Subject} from "rxjs";
import {DiagramService} from "@app/workflow-common/diagram-view2/services/diagram.service";
import {DagSourceModel} from "@app/workflow-common/services/DagSourceModel";

@Component({
    selector: 'app-node-view',
    templateUrl: './node-view.component.html',
    host: {
        class: 'cs-d-flex align-items-center'
    }
})
export class NodeViewComponent implements OnInit, OnDestroy {

    @Input() node: any;
    @Input() parentNode: any;
    @Input() hasParent = false;
    @Input() direction: 'vertical' | 'horizontal' = 'vertical';
    @Input() nodeOptions: INodeOptions;
    @Input() isNew:boolean = false;
    @Input() dagSourceModel: DagSourceModel;
    @Input() index: number = undefined;
    @Input() screenName: string;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private _diagramService: DiagramService
    ) { }

    ngOnInit() {
        this._diagramService.setParams({
            nodeOptions: this.nodeOptions,
        });
    }

    @HostBinding('style.flex-direction')
    get hostClass() {
        return this.direction === 'vertical' ? 'column' : '';
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
